import React from 'react'
import styled from 'styled-components'
import { Link } from 'lib/Link'
import { Text } from 'lib/Text'

const getDefaultText = (karmaRequirementForPreviousLevel: number) => `You now have now earned ${karmaRequirementForPreviousLevel}+ points`

const Container = styled(Text)`
  & {
    margin-top: 8px;
  }
`

interface Props {
  karmaRequirementForPreviousLevel: number
  karmaRequirementForNextLevel: number
  level: number
  karma: number
}

export const LevelUpCopies = ({ karmaRequirementForPreviousLevel, karmaRequirementForNextLevel, level, karma }: Props) => {
  switch (level || 0) {
    case 1:
      return (
        <Container size="p">
          {getDefaultText(karmaRequirementForPreviousLevel)}, access to the Thingdrop product testing program, as well as a badge alongside your
          profile photo.
        </Container>
      )
    case 6:
      const karmaForNextLevel = karmaRequirementForNextLevel - karma
      return (
        <Container size="p">
          {getDefaultText(karmaRequirementForPreviousLevel)}. You’re just {karmaForNextLevel} points away from your next reward.
        </Container>
      )
    case 7:
      return (
        <>
          <Container size="p">
            You unlocked access to the Slack community.{' '}
            <Link href="https://thingtesting.typeform.com/to/Ftz962gs">Confirm your interest in joining</Link>.
          </Container>
          <Container size="p">{getDefaultText(karmaRequirementForPreviousLevel)}.</Container>
        </>
      )
    case 10:
      return (
        <Container size="p">
          You are among the top most active members of our community. {getDefaultText(karmaRequirementForPreviousLevel)}.
        </Container>
      )
    default:
      return <Container size="p">{getDefaultText(karmaRequirementForPreviousLevel)}.</Container>
  }
}
